/**
 * @generated SignedSource<<6e484cc968300ed9d3f2b95246e2ad1a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type GameAggregator = "BJFUN" | "ENDORPHINA" | "HUB88" | "SEVEN" | "SOFT_SWISS" | "%future added value";
export type ThumbnailSliderSimilarGamesQuery$variables = {
  gameCode: string;
  mobile?: boolean | null;
  limit?: number | null;
};
export type ThumbnailSliderSimilarGamesQuery$data = {
  readonly listSimilarGames: ReadonlyArray<{
    readonly urlThumb: string | null;
    readonly aggregator: GameAggregator;
    readonly gameId: string;
    readonly category: string | null;
    readonly provider: string | null;
    readonly label: string;
    readonly customThumb: boolean;
  }>;
};
export type ThumbnailSliderSimilarGamesQuery = {
  variables: ThumbnailSliderSimilarGamesQuery$variables;
  response: ThumbnailSliderSimilarGamesQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "gameCode"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mobile"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "gameCode",
        "variableName": "gameCode"
      },
      {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
      },
      {
        "kind": "Variable",
        "name": "mobile",
        "variableName": "mobile"
      }
    ],
    "concreteType": "NormalizedGame",
    "kind": "LinkedField",
    "name": "listSimilarGames",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlThumb",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aggregator",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "gameId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "category",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customThumb",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ThumbnailSliderSimilarGamesQuery",
    "selections": (v3/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ThumbnailSliderSimilarGamesQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "7d58651e909b7ae5de5e2a158d7120ed",
    "id": null,
    "metadata": {},
    "name": "ThumbnailSliderSimilarGamesQuery",
    "operationKind": "query",
    "text": "query ThumbnailSliderSimilarGamesQuery(\n  $gameCode: String!\n  $mobile: Boolean\n  $limit: Int\n) {\n  listSimilarGames(gameCode: $gameCode, mobile: $mobile, limit: $limit) {\n    urlThumb\n    aggregator\n    gameId\n    category\n    provider\n    label\n    customThumb\n  }\n}\n"
  }
};
})();

(node as any).hash = "a18f73de1f5db5d2cc8920e3e2c9a5fb";

export default node;
